import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=60ba1470&scoped=true"
import script from "./packages.vue?vue&type=script&lang=js"
export * from "./packages.vue?vue&type=script&lang=js"
import style0 from "./packages.vue?vue&type=style&index=0&id=60ba1470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba1470",
  null
  
)

export default component.exports